<div class="basic-shipping-container">
  <form [formGroup]="shippingForm" class="shipping-form">
    
    <!-- Shipping Toggle: "Do you ship products?" -->
    <div class="shipping-toggle-section">
      <div class="toggle-group">
        <p-inputSwitch 
          formControlName="shippingEnabled" 
          (onChange)="onToggleShipping()"
          inputId="basicShippingToggle">
        </p-inputSwitch>
        <label for="basicShippingToggle" class="toggle-label">Do you ship products?</label>
      </div>
    </div>

    <!-- Shipping Content (Conditional) -->
    <div *ngIf="isShippingEnabled" class="shipping-content">
      
      <!-- Zones Section -->
      <div class="zones-section" formArrayName="zones">
        <h3 class="section-title">Shipping Zones</h3>
        <p class="section-description">Define shipping rates for different regions. A default US zone has been created.</p>

        <!-- Zones Panels -->
        <div class="zones-panels">
          <p-panel 
            *ngFor="let zone of zonesArray.controls; let i = index" 
            [header]="getZoneTabHeader(i)"
            class="zone-panel"
            [ngClass]="{'disabled-zone': !zone.get('isEnabled')?.value}"
            [toggleable]="true"
            [collapsed]="collapsedZones[i]"
            (onAfterToggle)="onZonePanelToggle(i, $event)">
            
            <!-- Zone Form Group -->
            <div [formGroupName]="i">
              
              <!-- Zone Name Input -->
              <div class="form-group">
                <label class="form-label">Zone Name</label>
                <input 
                  type="text" 
                  pInputText
                  formControlName="zoneName"
                  placeholder="Enter zone name"
                  (change)="validateZoneName(i)"
                  class="w-full"
                  [class.ng-invalid]="zone.get('zoneName')?.hasError('zoneExists')">
                <small class="error-message" *ngIf="zone.get('zoneName')?.hasError('zoneExists')">
                  Zone name already exists. Please use a different name.
                </small>
              </div>
 <!-- Zone Enable/Disable Toggle -->
              <div class="form-group">
                <div class="toggle-group">
                  <p-inputSwitch 
                    formControlName="isEnabled"
                    inputId="zoneEnabled{{ i }}">
                  </p-inputSwitch>
                  <label [for]="'zoneEnabled' + i" class="toggle-label">Zone Enabled</label>
                </div>
              </div>
              <!-- Countries/States Selection -->
              <div class="form-group">
                <label class="form-label">Countries/Regions</label>
                <p-multiSelect 
                  [options]="countryOptions"
                  formControlName="countries"
                  [selectionLimit]="isPk ? 1 : null"
                  (onChange)="onZoneCountryChange(zone)"
                  [maxSelectedLabels]="1"
                  selectedItemsLabel="{0} countries"
                  placeholder="Select countries"
                  styleClass="w-full">
                </p-multiSelect>
              </div>

              <div class="form-group">
                <label class="form-label">{{ zone.get('countries')?.value?.[0] === 'PK' ? 'Provinces' : 'States' }}</label>
                <p-multiSelect
                  [options]="regionOptions(zone)"
                  formControlName="states"
                  optionLabel="name"
                  optionValue="code"
                  [maxSelectedLabels]="3"
                  [selectedItemsLabel]="'{0} ' + regionWord(zone) + ' selected'"
                  [placeholder]="'Select ' + regionWord(zone) + ' (or leave blank for all)'"
                  styleClass="w-full">
                </p-multiSelect>
              </div>

              <!-- Rate Type Selection -->
              <div class="form-group">
                <label class="form-label">Shipping Rate Type *</label>
                <p-dropdown 
                  [options]="rateTypes" 
                  formControlName="rateType"
                  optionLabel="name" 
                  optionValue="code"
                  placeholder="Select rate type"
                  (onChange)="onZoneRateTypeChange(i)"
                  styleClass="w-full">
                </p-dropdown>
              </div>

              <!-- Flat Rate Cost (Conditional) -->
              <div class="form-group" *ngIf="zone.get('rateType')?.value === 'flat' || zone.get('rateType')?.value === 'free'">
                <label class="form-label">
                  Shipping Cost ({{ currency }}) 
                  <span *ngIf="zone.get('rateType')?.value === 'free'" class="badge-free">Free</span>
                </label>
                <p-inputNumber
                  formControlName="flatRate"
                  (onFocus)="selectOnFocus($event)"
                  mode="currency"
                  [currency]="currency"
                  currencyDisplay="symbol"
                  locale="en-US"
                  [minFractionDigits]="0"
                  [maxFractionDigits]="2"
                  placeholder="0.00"
                  styleClass="w-full">
                </p-inputNumber>
                <small
                  class="error-message"
                  *ngIf="
                    zone.get('rateType')?.value === 'flat' &&
                    zone.get('flatRate')?.invalid &&
                    submitAttempted
                  "
                >
                  For Flat Rate, shipping cost must be greater than 0.
                </small>
              </div>

              <!-- Store Pickup Option -->
              <div class="form-group">
                <label class="form-label">Enable Store Pickup?</label>
                <p-inputSwitch 
                  formControlName="isEnablePickup"
                  (onChange)="onPickupToggle(i)">
                </p-inputSwitch>
              </div>

              <!-- Pickup Cost (Conditional) -->
              <div class="form-group" *ngIf="zone.get('isEnablePickup')?.value">
                <label class="form-label">Pickup Cost ({{ currency }})</label>
                <p-inputNumber
                  formControlName="pickupCost"
                  (onFocus)="selectOnFocus($event)"
                  mode="currency"
                  [currency]="currency"
                  currencyDisplay="symbol"
                  locale="en-US"
                  [minFractionDigits]="2"
                  placeholder="0.00"
                  styleClass="w-full">
                </p-inputNumber>
              </div>

              <!-- USPS Services (Conditional) -->
              <div class="form-group" *ngIf="zone.get('rateType')?.value === 'calc'">
                <label class="form-label">Enable USPS Rates</label>
                <p-inputSwitch 
                  formControlName="uspsEnabled">
                </p-inputSwitch>
              </div>

              <div class="form-group" *ngIf="zone.get('rateType')?.value === 'calc' && zone.get('uspsEnabled')?.value">
                <label class="form-label">USPS Services</label>
                <p-multiSelect 
                  [options]="servicesList"
                  formControlName="uspsServices"
                  optionLabel="viewValue"
                  optionValue="value"
                  placeholder="Select USPS services"
                  styleClass="w-full">
                </p-multiSelect>
              </div>

             

              <!-- Delete Zone Button (Bottom of Panel) -->
              <div class="zone-actions" *ngIf="canRemoveZone()">
                <p-button 
                  label="Delete This Zone"
                  icon="pi pi-trash"
                  (onClick)="removeZone(i)"
                  severity="danger"
                  [text]="true"
                  styleClass="w-full p-button-danger-text">
                </p-button>
              </div>
            </div>

          </p-panel>
        </div>

        <!-- Add New Zone Button Section -->
        <div class="add-zone-section">
          <p-button 
            label="Add Zone"
            icon="pi pi-plus"
            (onClick)="addZone()"
            severity="info"
            styleClass="w-full p-button-outlined">
          </p-button>
        </div>
      </div>

    </div>

    <!-- Form Actions -->
    <div class="form-actions" *ngIf="isShippingEnabled">
      <p-button 
        label="Save Shipping Settings" 
        icon="pi pi-check"
        (onClick)="onSubmit()"
        styleClass="p-button-primary w-full">
      </p-button>
    </div>

  </form>
</div>
